import React from 'react';
import { Button, Modal, Typography, Divider } from 'antd'

/**
 *
 * @param {{
 *  visible: boolean,
 *  onClose?(): void,
 * }} props
 * @returns
 */
export function AyudaComServicioMaqPeriodoSubSolicitudPago(props) {
  return <Modal
    title='ADJUNTOS'
    visible={props.visible}
    onOk={props.onClose}
    width={'90%'}
    style={{
      height: '90%',
    }}
    onCancel={props.onClose}
    footer={[
      <Button
        key='close'
        onClick={props.onClose}
        children='Cerrar'
      />
    ]}
  >
    <div>
      <img
        src='https://i.imgur.com/4YxAVZL.jpeg'
        alt='Proceso'
        style={{
          width: '100%',
          // height: '700px'
        }}
      />
    </div>

    <Divider />

    <Typography.Paragraph>
      Este documento o procedimiento es propiedad exclusiva de nuestro sistema, aplicación o servicio.
    </Typography.Paragraph>

    <Typography.Paragraph>
      Se prohíbe estrictamente su reproducción total o parcial por parte de personal externo a nuestro sistema,
      aplicación o servicio sin la autorización expresa del propietario.
    </Typography.Paragraph>
  </Modal>
}
